(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function hhcFormatCollectionJudgeMeBadges(root = document) {
    root.querySelectorAll('collection-component .jdgm-prev-badge').forEach((badge) => {
      const count = badge.getAttribute('data-number-of-reviews');
      const average = badge.getAttribute('data-average-rating');

      if (!count) return;

      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (text && text.textContent.trim() !== count) {
        text.textContent = count;
      }

      if (average) {
        badge.querySelectorAll('*').forEach((element) => {
          if (element.children.length === 0 && element !== text) {
            const value = element.textContent.trim();
            if (value === average || value === Number(average).toFixed(1)) {
              element.style.display = 'none';
            }
          }
        });
      }
    });
  }

  function hhcInitCollectionJudgeMeBadges() {
    hhcFormatCollectionJudgeMeBadges();

    const collectionRoot = document.querySelector('collection-component');
    if (!collectionRoot) return;

    const observer = new MutationObserver(() => {
      hhcFormatCollectionJudgeMeBadges(collectionRoot);
    });

    observer.observe(collectionRoot, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hhcInitCollectionJudgeMeBadges, { once: true });
  } else {
    hhcInitCollectionJudgeMeBadges();
  }

  } catch(e) { console.error(e); }
})();
})();
